<vitamui-chip text="SEDA 2.1"></vitamui-chip>
<vitamui-chip text="SEDA 2.2"></vitamui-chip>
<vitamui-chip text="SEDA 2.3"></vitamui-chip>
